import { Col, Divider, Input, Row, Select, Typography, Checkbox, Form, Tooltip } from 'antd'
import { get, size } from 'lodash'
import React, { useEffect, useState } from 'react'
import MaskedInput from 'react-text-mask'
import { createNumberMask } from 'text-mask-addons'
import constants from '../../assets/constants'
import { MdInfoOutline } from 'react-icons/md'

const defaultMaskOptions = {
  prefix: '€ ',
  suffix: '',
  includeThousandsSeparator: true,
  thousandsSeparatorSymbol: '.',
  allowDecimal: true,
  decimalSymbol: ',',
  decimalLimit: 2, // how many digits allowed after the decimal
  integerLimit: 7,
  allowNegative: false,
  allowLeadingZeroes: false
}

const Spese = (props) => {
  const currencyMask = createNumberMask(defaultMaskOptions)

  const [checkedList, setCheckedList] = React.useState([])
  const [checkAll, setCheckAll] = React.useState(undefined)
  const [speseList, setSpeseList] = useState(constants.speseProps.map(spesa => spesa.value))

  const onChange = list => {
    setCheckedList(list)
    setCheckAll(list.length === speseList.length)
  }

  const onCheckAllChange = e => {
    setCheckedList(e.target.checked ? speseList : [])
    setCheckAll(e.target.checked)
  }
  useEffect(() => {
    props.addValue({ spese: checkedList })
    props.form.setFieldsValue({ spese: checkedList })
  }, [checkedList])
  useEffect(() => {
    setCheckedList(props.formValue.spese)
    if (size(props.formValue.spese) > 0) {
      setCheckAll(false)
    }
  }, [])
  return (
    <>
      <Typography.Title>Il tuo affitto</Typography.Title>
      <Row gutter={32}>
        <Col lg={8} sm={24} xs={24}>
          <Typography.Title level={5}>Canone mensile</Typography.Title>
          <Form.Item
            name='canone'
            rules={[
              {
                required: true,
                min: 0
              }
            ]}
          >
            <MaskedInput
              mask={currencyMask}
              inputMode='numeric'
              value={get(props, 'formValue.canone', '')}
              placeholder='Inserisci il canone'
              className='ant-input-affix-wrapper ant-input-affix-wrapper-lg'
            />
          </Form.Item>
        </Col>
        <Col lg={8} sm={24} xs={24}>
          <Typography.Title level={5}>Caparre</Typography.Title>
          <Form.Item
            name='caparre'
            rules={[
              {
                required: true
              }
            ]}
          >
            <Select
              style={{
                width: '100%'
              }}
              placeholder='Seleziona un numero di caparre'
            >
              {constants.caparre.map(caparra => (
                <Select.Option key={caparra.value} value={caparra.value}>{caparra.label}</Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Divider />
      <Row gutter={32}>
        <Col lg={8} sm={24} xs={24}>
          <Typography.Title level={5}>Spese a consumo a carico dell'inquilino</Typography.Title>
          <Form.Item
            name='spese'
          >
            <Row gutter={[12, 12]}>
              <Col span={24}>
                <Checkbox onChange={onCheckAllChange} checked={checkAll}>
                  Seleziona tutte
                </Checkbox>
              </Col>
            </Row>
            <Checkbox.Group onChange={onChange} value={checkedList}>
              <Row gutter={[12, 12]}>
                {constants.speseProps.map(spesa => (
                  <Col span={24} key={spesa.value}>
                    <Checkbox checked={checkedList.indexOf(spesa.value) >= 0} value={spesa.value}>{spesa.label}</Checkbox>
                  </Col>
                ))}
              </Row>
            </Checkbox.Group>
          </Form.Item>
        </Col>
        <Col lg={8} sm={24} xs={24}>
          <Row gutter={[12, 0]}>
            <Col>
              <Typography.Title level={5}>Spese fisse mensili</Typography.Title>
            </Col>
            <Col style={{ justifyContent: 'center', display: 'flex' }}>
              <Tooltip title='Inserisci i costi fissi non compresi nelle spese a consumo' placement='top' color='#029D9D'>
                <MdInfoOutline size={22} style={{ marginTop: 3 }} />
              </Tooltip>
            </Col>
          </Row>
          <Typography.Paragraph>Inserisci i costi fissi non compresi nelle spese a consumo</Typography.Paragraph>
          <Form.Item
            name='costoSpeseNonIncluse'
          >
            <MaskedInput
              mask={currencyMask}
              inputMode='numeric'
              value={get(props, 'formValue.costoSpeseNonIncluse', '')}
              placeholder='Inserisci il costo delle spese non incluse'
              className='ant-input-affix-wrapper ant-input-affix-wrapper-lg'
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  )
}

export default Spese
